import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver';
import { CpuImageSlicePath } from './CpuImageSliceRenderPath';
import { CpuVolumeSlicePath } from './CpuVolumeSliceRenderPath';
import { VtkImageMapperPath } from './VtkImageMapperRenderPath';
import { VtkVolumeSlicePath } from './VtkVolumeSliceRenderPath';
export function createDefaultPlanarRenderPaths() {
    return [
        new CpuImageSlicePath(),
        new CpuVolumeSlicePath(),
        new VtkImageMapperPath(),
        new VtkVolumeSlicePath(),
    ];
}
export function createPlanarRenderPathResolver(paths = createDefaultPlanarRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
